module.exports = __webpack_public_path__ + "97cc9c95066963a26a7dd518ac1727b0.png";